/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_Rep_MaxInputs */

const en_us2_workout_live_record_rep_max = /** @type {(inputs: Workout_Live_Record_Rep_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most reps at this load`)
};

const pt_br2_workout_live_record_rep_max = /** @type {(inputs: Workout_Live_Record_Rep_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais repetições com essa carga`)
};

const es_419_workout_live_record_rep_max = /** @type {(inputs: Workout_Live_Record_Rep_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más repeticiones con esta carga`)
};

const pt_pt2_workout_live_record_rep_max = /** @type {(inputs: Workout_Live_Record_Rep_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais repetições com esta carga`)
};

const fr_fr2_workout_live_record_rep_max = /** @type {(inputs: Workout_Live_Record_Rep_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de répétitions à cette charge`)
};

const de_de2_workout_live_record_rep_max = /** @type {(inputs: Workout_Live_Record_Rep_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meiste Wdh. mit diesem Gewicht`)
};

const it_it2_workout_live_record_rep_max = /** @type {(inputs: Workout_Live_Record_Rep_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più ripetizioni con questo carico`)
};

/**
* | output |
* | --- |
* | "Most reps at this load" |
*
* @param {Workout_Live_Record_Rep_MaxInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_rep_max = /** @type {((inputs?: Workout_Live_Record_Rep_MaxInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_Rep_MaxInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_rep_max(inputs)
	if (locale === "es-419") return es_419_workout_live_record_rep_max(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_rep_max(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_rep_max(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_rep_max(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_rep_max(inputs)
	return en_us2_workout_live_record_rep_max(inputs)
});
export { workout_live_record_rep_max as "workout-live.record_rep_max" }